// extracted by mini-css-extract-plugin
export default {"subheading-root":"Subheading_subheading-root__P02AH"};